import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

function NotFound() {
  const navigate = useNavigate();
  const isAuthenticated = authService.isAuthenticated();
  const usuarioAtual = authService.getUsuario();
  const isAtendente = usuarioAtual?.cargo === 'atendente';

  useEffect(() => {
    // Redirecionar automaticamente após 5 segundos
    const timer = setTimeout(() => {
      if (isAuthenticated) {
        // Se estiver logado, redireciona para o dashboard/consultas
        navigate(isAtendente ? '/consultas' : '/dashboard', { replace: true });
      } else {
        // Se não estiver logado, redireciona para a landing page
        navigate('/', { replace: true });
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, isAuthenticated, isAtendente]);

  const handleRedirect = () => {
    if (isAuthenticated) {
      navigate(isAtendente ? '/consultas' : '/dashboard', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
          <div className="col-md-6 text-center">
            <div className="error-page">
              <h2 className="headline text-warning" style={{ fontSize: '120px' }}>404</h2>

              <div className="error-content">
                <h3>
                  <i className="fas fa-exclamation-triangle text-warning"></i> Oops! Página não encontrada.
                </h3>

                <p className="mt-3">
                  A página que você está procurando não existe ou foi movida.
                  {isAuthenticated && (
                    <> Você será redirecionado para o {isAtendente ? 'painel de consultas' : 'dashboard'} em 5 segundos.</>
                  )}
                  {!isAuthenticated && (
                    <> Você será redirecionado para a página inicial em 5 segundos.</>
                  )}
                </p>

                <div className="mt-4">
                  <button 
                    className="btn btn-primary btn-lg"
                    onClick={handleRedirect}
                  >
                    <i className="fas fa-home mr-2"></i>
                    {isAuthenticated ? (isAtendente ? 'Ir para Consultas' : 'Ir para Dashboard') : 'Voltar ao Início'}
                  </button>
                </div>

                <div className="mt-4">
                  <p className="text-muted">
                    <small>
                      Se você chegou aqui através de um link, por favor reporte ao administrador.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
